import { BuildingLibraryIcon, ClockIcon } from '@heroicons/react/24/outline';
import { useId, useState } from 'react';
import type { DuitNowFlow } from '../../../../constants/duitnow.const';
import { PaymentStepLayout } from './PaymentStepLayout';
import { SelectableOptionCard } from './SelectableOptionCard';

interface Props {
  initial?: DuitNowFlow;
  onConfirm: (flow: DuitNowFlow) => void;
  onBack: () => void;
  isLoading?: boolean;
  noTopMargin?: boolean;
}

export function SelectDuitNowMethodStep({
  initial = 'consent',
  onConfirm,
  onBack,
  isLoading,
  noTopMargin
}: Readonly<Props>) {
  const [flow, setFlow] = useState<DuitNowFlow>(initial);
  const titleId = useId();

  return (
    <PaymentStepLayout
      backLabel="Payment Method"
      onBack={onBack}
      title="Add DuitNow AutoDebit"
      titleId={titleId}
      subtitle="Choose how you'd like to approve AutoDebit."
      continueDisabled={false}
      onContinue={() => onConfirm(flow)}
      isLoading={isLoading}
      bottomBackLabel="Go back to select Payment Method"
      noTopMargin={noTopMargin}
    >
      <div role="radiogroup" aria-labelledby={titleId} className="contents">
        <SelectableOptionCard
          icon={<BuildingLibraryIcon className="h-6 w-6" />}
          title="Select your bank"
          badge="Recommended"
          description="Choose your bank and continue to authorise AutoDebit."
          selected={flow === 'consent'}
          onSelect={() => setFlow('consent')}
        />
        <SelectableOptionCard
          icon={<ClockIcon className="h-6 w-6" />}
          title="Use DuitNow ID"
          description="Enter your DuitNow ID to send an authorization request."
          selected={flow === 'id'}
          onSelect={() => setFlow('id')}
        />
      </div>
    </PaymentStepLayout>
  );
}
